import { render, staticRenderFns } from "./kf.vue?vue&type=template&id=be5da224&scoped=true&"
import script from "./kf.vue?vue&type=script&lang=js&"
export * from "./kf.vue?vue&type=script&lang=js&"
import style0 from "./kf.vue?vue&type=style&index=0&id=be5da224&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be5da224",
  null
  
)

export default component.exports